/**
 * @namespace libraries
 */

import chartjs from './chartjs';
import d3 from './d3';
import googlecharts from './googlecharts';

/**
 * Default export container libraries and their default functions
 */
export default {
  chartjs,
  d3,
  googlecharts,
};
